export default "__VITE_ASSET__e51ac092__"